import { Link as CLink, Box, Flex, Heading, Text, Container } from "@chakra-ui/react";
import { Link } from "@inertiajs/react";
import { player_path } from "@/routes";
import { Game } from "@/types";
import { formatDate, formatTime } from "@/lib/utils";

interface Props {
  games: Game[];
}

export default function Index({ games }: Props) {
  return (
    <Container maxW="7xl" py={8}>
      {/* ヘッダーセクション */}
      <Flex justify="space-between" align="center" wrap="wrap" gap={4} mb={8} className="max-w-4xl mx-auto">
        <Box>
          <Heading size="lg" color="gray.800" mb={1}>
            対戦結果
          </Heading>
          <Text color="gray.600" fontSize="sm">
            あなたのこれまでの対戦結果一覧です
          </Text>
        </Box>
      </Flex>

      <div className="max-w-4xl mx-auto">
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white shadow rounded-lg divide-y divide-gray-200">
            <thead className="text-gray-600">
            <tr>
              <th className="px-4 py-2 text-left">対戦相手</th>
              <th className="px-4 py-2 text-left">結果</th>
              <th className="px-4 py-2 text-left">日時</th>
            </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
            {games.map(game => (
              <tr key={game.id} className="hover:bg-gray-50">
                <td className="px-4 py-2">
                  <CLink asChild>
                    <Link href={player_path(game.player2.player_id)} className="block">
                      {game.player2.display_name}
                      <p className="text-xs text-gray-500">ID: {game.player2.player_id}</p>
                      <p className="text-xs text-gray-500">RT: {game.player2_rating_score}</p>
                    </Link>
                  </CLink>
                </td>
                <td className="px-4 py-2 text-nowrap">
                  {game.player1_point > game.player2_point ? (
                    <span className="text-red-700 pr-2">W</span>
                  ) : (
                    <span className="text-blue-700 pr-2">L</span>
                  )}
                  <span>{game.player1_point}</span>-<span>{game.player2_point}</span>
                </td>
                <td className="px-4 py-2">
                  {formatDate(game.created_at)}
                  <br />
                  {formatTime(game.created_at)}
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        </div>
      </div>
    </Container>
  );
}
